import {emailValidation, phoneNumberValidation, requiredValidation} from "../../forms/Validation";

export const required = requiredValidation();
export const email = emailValidation();
export const phone = phoneNumberValidation();